/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LanguageEnum = {
    En: 'EN',
    De: 'DE',
    Fr: 'FR',
    It: 'IT',
    Es: 'ES'
} as const;
export type LanguageEnum = typeof LanguageEnum[keyof typeof LanguageEnum];


export function instanceOfLanguageEnum(value: any): boolean {
    for (const key in LanguageEnum) {
        if (Object.prototype.hasOwnProperty.call(LanguageEnum, key)) {
            if (LanguageEnum[key as keyof typeof LanguageEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LanguageEnumFromJSON(json: any): LanguageEnum {
    return LanguageEnumFromJSONTyped(json, false);
}

export function LanguageEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageEnum {
    return json as LanguageEnum;
}

export function LanguageEnumToJSON(value?: LanguageEnum | null): any {
    return value as any;
}

export function LanguageEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): LanguageEnum {
    return value as LanguageEnum;
}

